/**
 * Sample stay for the Hubwayz hotel preview.
 * Room cards use the API amount in the search currency.
 * Shekels are calculated only in the order summary.
 */

export const HUBWAYZ_HOTEL_PREVIEW_ID = "10426";

export const HUBWAYZ_PREVIEW_FX_RATE = 3.72;

export const HUBWAYZ_HOTEL_PREVIEW = {
  hotelName: "מלון קורינתיה בודפשט",
  hotelNameEn: "Corinthia Budapest",
  stars: 5,
  score: "9.1",
  scoreLabel: "מצוין",
  city: "בודפשט",
  country: "הונגריה",
  address: "Erzsébet körút 43–49",
  checkIn: "12/12/2026",
  checkOut: "16/12/2026",
  nights: 4,
  roomsCount: 1,
  adults: 2,
  children: 0,
  searchCurrency: "USD",
  paymentFxRate: HUBWAYZ_PREVIEW_FX_RATE,
  paymentFxLabel: "1 USD = ₪3.72",
  gallery: [
    "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1400&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=1400&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=1400&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1400&q=80&auto=format&fit=crop",
  ],
  about: [
    "מלון חמישה כוכבים על שדרת ארז'בט, במרחק הליכה קצר מהדנובה ומרובע היהודי. הלובי, בריכת הגג והחדרים מוצגים כאן כדוגמה ויזואלית בלבד.",
    "השהות בדוגמה היא ארבעה לילות לשני מבוגרים בחדר אחד. מחיר החדר הוא מחיר API בדולרים. ההמרה לשקלים נעשית רק בסיכום.",
  ],
};

function roomPhoto(id) {
  return `https://images.unsplash.com/${id}?w=960&q=80&auto=format&fit=crop`;
}

export const HUBWAYZ_HOTEL_PREVIEW_ROOMS = [
  {
    id: "std-bb",
    name: "Standard Double Room",
    beddingLabel: "1 Double Bed",
    photos: [
      roomPhoto("photo-1631049307264-da0ec9d70304"),
      roomPhoto("photo-1611892440504-42a792e24d32"),
      roomPhoto("photo-1590490360182-c33d57733427"),
    ],
    boardLabel: "לינה וארוחת בוקר",
    boardSummary: "לינה וארוחת בוקר",
    capacityLabel: "2 מבוגרים",
    cancellationSummary: "ביטול ללא עלות עד 01/12/2026",
    cancellationFree: true,
    cancellationFullyRefundable: true,
    immediateConfirm: true,
    apiAmountUsd: 1296,
  },
  {
    id: "dlx-bb",
    name: "Deluxe Room",
    beddingLabel: "1 King Bed",
    photos: [],
    boardLabel: "לינה וארוחת בוקר",
    boardSummary: "לינה וארוחת בוקר",
    capacityLabel: "2 מבוגרים",
    cancellationSummary: "לא ניתן לביטול",
    cancellationFree: false,
    cancellationFullyRefundable: false,
    cancellation: { type: "non-refundable" },
    immediateConfirm: true,
    apiAmountUsd: 1132,
  },
  {
    id: "sup-hb",
    name: "Superior Room",
    beddingLabel: "1 Double Bed",
    photos: [
      roomPhoto("photo-1618773928121-c32242e63f39"),
      roomPhoto("photo-1596394516093-501ba68a0ba6"),
      roomPhoto("photo-1505693416388-ac5ce068fe85"),
    ],
    boardLabel: "חצי פנסיון",
    boardSummary: "חצי פנסיון",
    capacityLabel: "2 מבוגרים",
    cancellationSummary: "ניתן לביטול",
    cancellationFree: false,
    cancellationFullyRefundable: true,
    cancellation: { type: "refundable" },
    immediateConfirm: true,
    apiAmountUsd: 1516,
  },
  {
    id: "suite-ai",
    name: "Junior Suite",
    beddingLabel: "1 King Bed",
    photos: [
      roomPhoto("photo-1522771739844-6a9f6d5f14af"),
      roomPhoto("photo-1591088398332-8a7791972843"),
      roomPhoto("photo-1571896349842-33c89424de2d"),
    ],
    boardLabel: "הכל כלול",
    boardSummary: "הכל כלול",
    capacityLabel: "2 מבוגרים",
    cancellationSummary: "לא ניתן לביטול",
    cancellationFree: false,
    cancellationFullyRefundable: false,
    cancellation: { type: "non-refundable" },
    immediateConfirm: false,
    apiAmountUsd: 1930,
  },
  {
    id: "family-ro",
    name: "Family Room",
    beddingLabel: "1 Double Bed · 1 Single Bed",
    photos: [
      roomPhoto("photo-1560185007-cde436f6a4d0"),
      roomPhoto("photo-1554995207-c18c203602cb"),
      roomPhoto("photo-1616594039964-ae9021a400a0"),
    ],
    boardLabel: "לינה בלבד",
    boardSummary: "לינה בלבד",
    capacityLabel: "2 מבוגרים",
    cancellationSummary: "ביטול ללא עלות עד 20/11/2026",
    cancellationFree: true,
    cancellationFullyRefundable: true,
    immediateConfirm: false,
    apiAmountUsd: 1073,
  },
].map((room) => ({
  ...room,
  agentNetIls: Math.round(room.apiAmountUsd * HUBWAYZ_PREVIEW_FX_RATE),
}));

export const HUBWAYZ_PREVIEW_STAGES = [
  { id: "results", label: "תוצאות", done: true },
  { id: "detail", label: "בחירת חדר", active: true },
  { id: "passengers", label: "נוסעים", stub: true },
  { id: "payment", label: "תשלום", stub: true },
];
